import { useEffect, useState } from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import api from "../services/api";
import { getParam, getPathName } from "../library";

import { Oval } from  "react-loader-spinner";

import IncluiFilaAtendimento from "./FilaAtendimento";
import ConfirmaChegada from "./ConfirmaChegada";
import PesquisaSatisfacao from "./PesquisaSatisfacao";
import Page404 from "./404";


function CustomRoute({ isPrivate, ...rest }) { 
    return <Route {...rest} />;
}

export const Loading = ({ text }) => {
  const loadingContainer = {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",    
    "backgroundColor": "#ededed",
    "flexDirection": "column",
    "height": "100vh",
    "width": "100vw",
    "gap": "45px"
  };

  return (
    <div style={loadingContainer}>
        <Oval
            height={60}
            width={60}
            color="#1e90ff"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#1e90ff"
            strokeWidth={3}
            strokeWidthSecondary={3} 
          />
          {text ? <span style={{fontSize: "18px", fontWeight: 600}}>{text}</span> : null}
      </div>
  )
}

export default function Routes() { 
  const [loading, setLoading] = useState(true);
  const [validouLocal, setValidouLocal] = useState(false);

  const codLocal = getParam("codLocal");
  const rota = getPathName();
  const rotaLivre = ["/confirma-chegada", "/pesquisa-satisfacao"];

  useEffect(() => {
    (async () => {
      for (let i = 0; i < rotaLivre.length; i++)
        if (rota === rotaLivre[i]) {
          setValidouLocal(true);
          setLoading(false);
          return;
        }

      var response;
      try {
        response = await (await api.post(
          "/site-atendimento/valida-local", 
          {
            codLocal: codLocal
          }
        )).data;        
      } catch {
      } finally {
        setLoading(false);
        if (response?.name) 
          setValidouLocal(true);
      }
    })();   
  }, []);

  if (loading)
    return <Loading />
  else {
    return (
      <BrowserRouter>
        {
          validouLocal
          ? <Switch>
              <CustomRoute exact path="/inclui-fila-atendimento" component={IncluiFilaAtendimento} />
              <CustomRoute exact path="/confirma-chegada" component={ConfirmaChegada} />
              <CustomRoute exact path="/pesquisa-satisfacao" component={PesquisaSatisfacao} />

              <CustomRoute path="*" component={Page404} />
            </Switch>
          : <Switch><CustomRoute path="*" component={Page404} /></Switch>
        }
      </BrowserRouter>
    );
  }
};